<div class="yo-submenu">
  <div class="yo-close-submenu" (click)="closeDropMenu()"><i class="fas fa-times"></i></div>
  <ul>
    <li *ngFor="let row of rows" (click)="onChooseRow(row)"><i [class]="row.iconClass"></i> {{ row.label }}</li>
  </ul>
</div>
